"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$paragraphItemTitle = exports.$stdSubitem3Title = exports.$stdSubitem2Title = exports.$stdSubitem1Title = exports.$stdItemTitle = exports.$stdParagraphNum = void 0;
const factory_1 = __importDefault(require("../factory"));
const lexical_1 = require("./lexical");
const num_1 = require("../../../law/num");
const reStdParagraphNum = new RegExp(`^(?:○?[0123456789０１２３４５６７８９]+|[${num_1.circledDigitChars}])`);
exports.$stdParagraphNum = factory_1.default
    .withName("stdParagraphNum")
    .regExp(reStdParagraphNum) // e.g. "１", "２０",  "○１", "○２０", "①"
;
exports.$stdItemTitle = factory_1.default
    .withName("stdItemTitle")
    .regExp(new RegExp(`^[${lexical_1.kanjiDigits}]+(?:[のノ[${lexical_1.kanjiDigits}]+])*`)) // e.g. "十二", "一の二", "一の二の三"
;
exports.$stdSubitem1Title = factory_1.default
    .withName("stdSubitem1Title")
    .regExp(new RegExp(`^[${num_1.irohaChars}]`)) // e.g. "イ"
;
exports.$stdSubitem2Title = factory_1.default
    .withName("stdSubitem2Title")
    .regExp(new RegExp(`^[(（](?:[${lexical_1.kanjiDigits}]+|[0123456789０１２３４５６７８９]+)[)）]`)) // e.g. "（十二）", "(１０)", "(1)"
;
exports.$stdSubitem3Title = factory_1.default
    .withName("stdSubitem3Title")
    .regExp(/^[(（][a-zA-Zａ-ｚＡ-Ｚ]+[)）]/) // e.g. "（ａ）", "(b)"
;
const paragraphItemTitlePtn1 = "(?:[0123456789０１２３４５６７８９]+|[a-zA-Zａ-ｚＡ-Ｚ])[.．]"; // e.g. "１．", "a."
const paragraphItemTitlePtn2 = `[(（](?:[0123456789０１２３４５６７８９]+|[${num_1.irohaChars}]|[${lexical_1.kanjiDigits}]+|[a-zA-Zａ-ｚＡ-Ｚ]+)[)）]`; // e.g. "（十二）", "（イ）", "(１０)", "(a)"
const paragraphItemTitlePtn3 = `(?:[0123456789０１２３４５６７８９]+|[${num_1.irohaChars}]|[${lexical_1.kanjiDigits}]+|[a-zA-Zａ-ｚＡ-Ｚ]+|[${num_1.circledDigitChars}]|[⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇])`; // e.g. "１０", "イ", "十一", "①", "⑴"
const paragraphItemTitleFragmentPtn = `(?:${paragraphItemTitlePtn1}|${paragraphItemTitlePtn2}|${paragraphItemTitlePtn3})`;
const paragraphItemTitlePtn = `^○?${paragraphItemTitleFragmentPtn}(?:[のノ](?:${paragraphItemTitleFragmentPtn}))*`;
exports.$paragraphItemTitle = factory_1.default
    .withName("paragraphItemTitle")
    .sequence(s => s
    .and(r => r.regExp(new RegExp(paragraphItemTitlePtn)))
    .action(({ text }) => {
    return {
        value: text(),
        errors: [],
    };
}));
exports.default = exports.$paragraphItemTitle;
//# sourceMappingURL=$paragraphItemTitle.js.map